import _Paper from "@material-ui/core/esm/Paper";
import React from 'react';
import classnames from 'classnames';
import classes from './giveaway-paper.scss';
export const GiveawayPaper = props => {
  const paperClasses = {
    root: classnames(classes.paper, props.className)
  };
  return /*#__PURE__*/React.createElement(_Paper, {
    classes: paperClasses
  }, props.children);
};